// extracted by mini-css-extract-plugin
export default {"body":"Card_body__0XTEW"};